import { FormBuilder, FormGroup, Validators } from '@angular/forms';

export class BuildingAddressModel {
    businessAddress: {
        fullAddress: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null
    };
    isBussinessAddressVerified: boolean = null;

    static asForm(fb: FormBuilder): FormGroup {
        return fb.group({
            businessAddress: fb.group({
                fullAddress: [, Validators.required],
                address1: [],
                address2: [],
                city: [],
                state: [],
                zip: []
            }),
            isBussinessAddressVerified: []
        });
    }

    static generateForm(fb: FormBuilder, model: BuildingAddressModel): FormGroup {
        const form = BuildingAddressModel.asForm(fb);
        form.setValue(model);
        return form;
    }
}
